export default __webpack_public_path__ + "static/media/InezLovelace.4a66d55c.png";